import { BASE_URL } from '../../constants/urls'
import { api } from './interceptor'

const deleteApi = (token, path, payload = {}) => {
	return api.delete(BASE_URL + path, {
		data: payload,
		headers: {
			'x-auth-token': token,
		},
	})
}

export { deleteApi }
